<template>
  <div>
    <div style="margin-bottom: 10px;">
      <el-button type="primary" @click="handleAdd">新增</el-button>
    </div>
    <el-form :model="searchForm" class="search-form" ref="searchFormRef">
      <el-form-item label="" prop="city">
        <el-input
          style="width:200px"
          :maxlength="255"
          v-model="searchForm.city"
          placeholder="按城市搜索"
        />
      </el-form-item>
      <el-form-item>
        <!-- 操作按钮 -->
        <el-button type="warning" @click="onFormSearch">查询</el-button>
        <el-button type="warning" plain @click="onFormReset">重置</el-button>
      </el-form-item>
    </el-form>
    <my-table
      :indexType="true"
      :tableData="table.tableData"
      :headerList="table.headerList"
      :loading="table.loading"
      :page-size="params.pageSize"
      :currentPage="params.pageNo"
      :total="table.total"
      @currentPage-change="handlePageChange"
      @sizePage-change="handleSizeChange"
    >
      <!-- 自定义内容 -->
      <template v-slot:cityNameList="{ data }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="data.cityNameList"
          placement="top-start"
          popper-class="tool-tipgz"
        >
          <div class="overflow-ellipsis-2line">{{data.cityNameList}}</div>
        </el-tooltip>
      </template>
      <template v-slot:floatUnit="{ data }">
        {{ data.floatUnit === 0 ? '元' : '%' }}
      </template>
      <template v-slot:operation="{ data }">
        <el-link style="margin: 0 10px;" type="danger" @click="handelDelete(data)">删除</el-link>
        <el-link style="margin: 0 10px;" type="primary" @click="handelEdit(data)">编辑</el-link>
      </template>
    </my-table>
    <priceFloatPop ref="priceFloatPopRef" @refresh="handleRefresh"></priceFloatPop>
  </div>
</template>

<script>
import myTable from '@/components/my-table.vue'
import mini from "@/api/mini";
const MiniModel = new mini();
import debounce from "@/utils/debounce.js";
import priceFloatPop from '@/views/pc/channelMiniProgram/set/priceFloat/priceFloatPop.vue'
export default {
  name: "priceFloatList",
  components:{
    myTable,
    priceFloatPop,
  },
  data() {
    return {
      searchForm:{
        city: '',
      },
      params:{
        pageNo: 1,
        pageSize: 10,
      },
      table:{
        loading: false,
        total: 0,
        tableData: [],
        headerList:[
          {
            prop: 'cityNameList',
            label: '城市',
            width: '300',
            customRender:'cityNameList',
          },
          {
            prop: 'initPriceFloat',
            label: '市场价浮动价',
            width: '180',
          },
          {
            prop: 'discountPriceFloat',
            label: '特惠购票浮动价',
            width: '180',
            // customRender:'customName'
          },
          {
            prop: 'fastPriceFloat',
            label: '快速购票浮动价',
            width: '180',
          },
          {
            prop: 'floatUnit',
            label: '单位',
            width: '100',
            customRender:'floatUnit'
          },
          {
            prop: 'operation',
            label: '操作',
            width: '120',
            customRender: 'operation',
            fixed: 'right', //是否固定列
          }
        ],
      },
      cityIdList:[],
    }
  },
  created() {
    console.log('createdcreated')
    this.getList()
  },
  methods:{
    onFormSearch() {
      debounce(
        () => {
          this.$refs['searchFormRef'].validate((valid) => {
            if (valid) {
              this.params.pageNo = 1;
              this.getList();
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        500,
        true
      );
    },
    onFormReset() {
      debounce(()=> {
        this.searchForm = {
          city: '',
        }
        this.params.pageNo = 1
        this.$refs['searchFormRef'].resetFields();
        this.getList()
      },1000,true)
    },
    async getList() {
      this.table.loading = true;
      const res = await MiniModel.priceFloatList({
        ...this.params,
        ...this.searchForm,
        appKey: localStorage.getItem('appKeyMini'),
      })
      console.log(res,'res====222')
      this.table.loading = false;
      if(res.data.code !== 200) {
        this.$message.error(res.data.message)
        return
      }
      this.table.tableData = res.data.data.list.map(item => {
        return {
          ...item,
          cityNameList:item.cityNameList.join(','),
        }
      })
      this.table.total = res.data.data.total;
      this.params.pageNo = res.data.data.pageNo
      this.cityIdList = res.data.data.cityIdList
    },
    async handelDelete(row) {
      this.$confirm('确认删除这条浮动价格设置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await MiniModel.priceFloatSettingDelete({
          id:row.id,
          appKey: localStorage.getItem('appKeyMini'),
        })
        if(res.data.code !== 200) {
          this.$message({
            type: 'error',
            message: res.data.message,
          })
        }
        this.handleRefresh()
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
      });

    },
    handleAdd() {
      this.$refs.priceFloatPopRef.handleOpen(0,null,this.cityIdList)
    },
    handelEdit(row) {
      // console.log(row.cityIdList,'row.cityIdList',this.cityIdList)
      let list = this.cityIdList.filter(item => !row.cityIdList
        .includes(item));
      // console.log(list,'listlist')
      this.$refs.priceFloatPopRef.handleOpen(1,row,list)
    },
    handleRefresh() {
      console.log('刷新列表111');
      this.getList()
    },
    // 分页
    handlePageChange(val) {
      this.params.pageNo = val
      this.getList()
    },
    // 每页显示条数
    handleSizeChange(val) {
      this.params.pageSize = val
      this.getList()
    },
  },
}
</script>

<style scoped lang="less">
.overflow-ellipsis-2line {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 限制显示2行 */
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style>
.tool-tipgz {
  max-width: 600px;
}
.el-tooltip__popper {
  max-width: 60% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/set/priceFloat/priceFloatList.vue